
const digest = 'c083b1f366bd480c6e9b8d1a0b90cca3d8e6759ec824cf001088d4748cea1b55';
const classes = {"container":"_container_1cu90_1","textField":"_textField_1cu90_19","dropdown":"_dropdown_1cu90_33"};
const css = `._container_1cu90_1 {
  position: relative;
}
._container_1cu90_1 .form-group {
  margin-bottom: 0;
}
._container_1cu90_1::before {
  content: "";
  background-image: url("/dist/icons/magnifying-glass-solid-full.png");
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  display: block;
  position: absolute;
  bottom: 15px;
  left: 15px;
  z-index: 1;
}
._container_1cu90_1 input._textField_1cu90_19 {
  padding-left: 40px !important;
}
._container_1cu90_1 input.is-invalid {
  border-color: #b20d0d;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
._container_1cu90_1 input.is-invalid:focus {
  border-color: #b20d0d;
}

._dropdown_1cu90_33 {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 5;
  width: 100%;
  margin-top: 4px;
  background: #fff;
  border: 1px solid #e2e5ed;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 240px;
  overflow-y: auto;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  